// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LearnMoreLink_wrapper__EVFpU","icon":"LearnMoreLink_icon__JbkX1","textWrapper":"LearnMoreLink_textWrapper__mLiXk","subheader":"LearnMoreLink_subheader__Govdy"};